<template>
  <div class="page">
    <div style="display: flex; justify-content: space-between; align-items: end">
      <div>
        <h2><span class="fa fa-plus-circle"></span> Create lesson</h2>
        <p class="mb-4">Fill out the needed fields to create your lesson.<br /></p>
      </div>
    </div>

    <div class="page-container">
      <form>
        <label for="title">Title</label>
        <InputText v-model="title" class="w-full" placeholder="Title" />

        <small id="titleHelp" class="form-text">E.g.: <i>My Lesson</i></small>
      </form>
      <Button @click="addLesson" label="Create" class="mt-4" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateLessonPage",
  data() {
    return {
      title: ""
    };
  },
  methods: {
    async addLesson() {
      const result = await this.$store.dispatch("lessons/add", {
        title: this.title
      });

      if (!result) {
        return;
      }

      this.$router.push({
        name: "edit-lesson",
        params: { lessonId: result.id }
      });
    }
  }
};
</script>
